import { call, select } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { getAuthenticationJwtSelector } from '../../login/selectors/getAuthenticationJwt.selector'
import { getPcrBackupConfigSelector } from '../store/pcrBackup.selectors'
import { IPcrBackupConfig, IPcrBackupMetadata } from '../store/pcrBackup.types'
import { PcrBackupMetadataService } from '../services/pcrBackupMetadata.service'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IPcr } from '../../pcr/store/pcr.types'
import { triggerBackup } from './triggerBackup.saga'
import { isOnline } from '../../../utilities/isOnline.util'
import Logger from '../../../services/logger.service'

export function* drainOverdueAndPending() {
  const authJwt: string = yield select(getAuthenticationJwtSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  if (!authJwt || !serviceId || !isOnline()) return

  const config: IPcrBackupConfig = yield select(getPcrBackupConfigSelector)
  if (config.disabled) {
    Logger.info('drainOverdueAndPending: PCR backup is disabled via app settings')
    return
  }
  const intervalMs = config.minIntervalMinutes * 60 * 1000

  const metadataService = new PcrBackupMetadataService(serviceId)
  const overdue: IPcrBackupMetadata[] = yield call([metadataService, metadataService.getOverdueBackupPcrs], intervalMs)
  if (overdue.length === 0) return

  Logger.info(`drainOverdue: draining ${overdue.length} overdue PCR(s) on login`)

  const pcrDocsService = new PcrDocsService(serviceId)

  for (const entry of overdue) {
    const pcr: IPcr | null = yield call([pcrDocsService, pcrDocsService.getPCR], entry.pcrId)
    if (!pcr) {
      Logger.warn(`drainOverdue: PCR not found for pcrId=${entry.pcrId} — deleting stale metadata`)
      yield call([metadataService, metadataService.deleteMetadata], entry.pcrId)
      continue
    }
    // Pass DB-sourced metadata directly — Redux only holds the currently open chart
    yield call(triggerBackup, pcr, entry)
  }
}
